import React from 'react'
import Helmet from 'react-helmet'
import get from 'lodash/get'
import Layout from '../components/layout'
import ContactForm from '../components/contact-form'

class ContactPage extends React.Component {
  render() {
    const siteTitle = get(this, 'props.data.site.siteMetadata.title')
    const color = 'rgb(211, 232, 225)'
    const category = 'Contact Us'
    const description = ''

    return (
      <Layout location={this.props.location} style={{ backgroundColor: color }}>
        <Helmet
          htmlAttributes={{ lang: 'en' }}
          meta={[
            { name: 'description', content: description },
            { property: 'og:title', content: category },
            {
              property: 'og:description',
              content: description,
            },
            {
              property: 'twitter:title',
              content: category,
            },
            {
              property: 'twitter:description',
              content: description,
            },
          ]}
          title={siteTitle}
        />
        <div className=" mx-auto max-w-screen-xl pt-6 md:p-12">
          {/* //headline */}
          <div className="text-center p-4">
            <h2 className="text-3xl tracking-tight leading-10 font-extrabold text-gray-900 sm:text-4xl sm:leading-none md:text-5xl mb-4 mt-6">
              Contact Us
              <br />
            </h2>
          </div>

          <div className="text-xl p-6 pb-2 leading-normal  border rounded border-light-grey bg-white m-2">
            <div className="text-blue-700  mx-auto max-w-screen-md text-center">
              <p>We'd love to hear from you! Let us know how we can help.</p>

              <p>
                If you are looking for information about our community, job
                board or sponsorships, please do{' '}
                <a href="/work-with-us">check here for details</a>.
              </p>
            </div>
            <ContactForm />
          </div>
        </div>
      </Layout>
    )
  }
}

export default ContactPage
